import { render, staticRenderFns } from "./TemplateStepFinalizar.vue?vue&type=template&id=9b6f32ca&scoped=true"
import script from "./TemplateStepFinalizar.vue?vue&type=script&lang=js"
export * from "./TemplateStepFinalizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6f32ca",
  null
  
)

export default component.exports